import styled from 'styled-components';

export const PublicMoreEvidenceContainer = styled.div`
  background: ${(props) => props.theme.newPalette.neutral.N0};
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 30px;
  overflow-y: auto;
  width: calc(100% - 80px);

  & p {
    ${(props) => props.theme.newTypography.textStyleBody}
  }
`;

export const Header = styled.div`
  ${(props) => props.theme.newTypography.textStyleHeading}
  margin: 30px 0;
  @media screen and (min-width: 0px) and (max-width: 480px) {
    margin: 25px 0 10px 0;
  }
`;

export const AdditionalEvidenceHeader = styled(Header)<{
  caseIsNotClosed: boolean;
}>`
  margin: ${(props) => (props.caseIsNotClosed ? '0 0 10px 0' : '30px 0 0 0')};
`;

export const FileUploadContainer = styled.div`
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.7);
  box-shadow: 0px 0px 11px -1px rgba(150, 150, 150, 0.3);
  width: 90%;
  height: min-content;
  color: ${(props) => props.theme.newPalette.neutral.N0};
  ${(props) => props.theme.newTypography.textStyleBodySmall}
  text-decoration: none;
  display: flex;
  margin: 30px 0;
  padding: 25px;

  @media screen and (min-width: 0px) and (max-width: 480px) {
    border-radius: 0;
    box-shadow: none;
    width: 100%;
    padding: 0;
    margin-top: 0;
  }
`;

export const DescriptionContainer = styled.div`
  ${(props) => props.theme.newTypography.textStyleBodySmall}
  width: 90%;

  @media screen and (min-width: 0px) and (max-width: 480px) {
    width: 100%;
  }
`;

export const StyledIconContainer = styled.div`
  margin-right: 10px;
`;

export const StyledText = styled.div`
  ${(props) => props.theme.newTypography.textStyleBodySmall}
  padding-top: 20px;
  margin-top: 0;
  text-align: center;
  color: ${(props) => props.theme.newPalette.neutral.N800};
`;

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 320px;
  margin-bottom: 20px;
  padding: 20px 0;
`;
